import { APP_STATUS, type ApplicationStatus, type GigApplication } from "../../api/gigboard";

/** Gigs the participant tapped Apply on, newest first, each with a status they can update. */
export function MyApplications({
  applications,
  onStatus,
}: {
  applications: GigApplication[];
  onStatus: (application: GigApplication, status: ApplicationStatus) => void;
}) {
  if (!applications.length) {
    return (
      <p className="text-[13px] text-text-muted">
        Nothing yet. Gigs you tap Apply on appear here, so you can keep track of them.
      </p>
    );
  }
  const sorted = [...applications].sort(
    (a, b) => new Date(b.clickedAt).getTime() - new Date(a.clickedAt).getTime(),
  );
  return (
    <div className="my-3 rounded-[var(--radius-card)] border border-border bg-surface px-4 py-1.5">
      {sorted.map((app) => (
        <div
          key={app.id}
          className="flex flex-wrap items-center justify-between gap-2.5 border-b border-border py-3 last:border-b-0"
        >
          <div className="min-w-[200px] flex-1">
            <b>{app.title}</b>
            <div className="text-[13px] text-text-muted">
              {app.source} · clicked{" "}
              {new Date(app.clickedAt).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
              })}
            </div>
          </div>
          <select
            aria-label={`Status of ${app.title}`}
            className="min-h-[42px] rounded-[var(--radius-control)] border-[1.5px] border-border bg-surface px-2.5 text-[13.5px]"
            value={app.status}
            onChange={(event) => onStatus(app, event.target.value as ApplicationStatus)}
          >
            <option value="clicked">Not updated yet</option>
            {APP_STATUS.map(([value, label]) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
        </div>
      ))}
    </div>
  );
}
